'use client';

import { useNativeTokens } from '~/(tenant)/_components/native/_lib/use-native-tokens';

/**
 * 1px line at low opacity (8% of foreground). Replaces card borders for
 * the editorial layout — between rows of a list, between stats columns,
 * above/below a stats strip.
 */
export function HairlineDivider({
  orientation = 'horizontal',
  inset = 0,
}: {
  orientation?: 'horizontal' | 'vertical';
  /** Horizontal margin on each side (px). 22 matches the standard section gutter. */
  inset?: number;
}) {
  const t = useNativeTokens();
  if (orientation === 'vertical') {
    return <div style={{ width: 1, alignSelf: 'stretch', backgroundColor: t.line }} aria-hidden />;
  }
  return (
    <div
      style={{
        height: 1,
        backgroundColor: t.line,
        marginLeft: inset,
        marginRight: inset,
      }}
      aria-hidden
    />
  );
}
